/* eslint-disable no-undef */

import React, {Component} from 'react'
import parse from 'html-react-parser';
import { Link } from '@material-ui/core';

export default class TextLabel extends Component {
    state = {}

    getProcessedStr(str) {
        let returnArr = [str]
        let arr = []
        while (!!(arr = this.getNextRegexIteration(returnArr))) { //This is to remove warning for typo which doesn't exist
            returnArr = arr
        }
        if (returnArr.length === 0) {
            return str
        }
        return returnArr
    }

    getNextRegexIteration(arr) { //If you add more possible elements to replace, make proper functionality to check first element
        let str = arr[arr.length - 1]
        arr.splice(-1, 1)
        let foundBold = str.match(/(<b>(.*?)<\/b>)/);
        let boldPos = null
        if (foundBold) {
            boldPos = str.indexOf(foundBold[0])
        }
        let foundLink = str.match(/(<a href="([^"]*)">(.*?)<\/a>)/);
        let linkPos = null
        if (foundLink) {
            linkPos = str.indexOf(foundLink[0])
        }
        if (foundLink && (!foundBold || linkPos < boldPos)) {
            str = str.replace(foundLink[0], '')
            let newArr = [str.substr(0, linkPos), <Link href={foundLink[2]} target="_blank" key={arr.length}>{foundLink[3]}</Link>, str.substr(linkPos)];
            return [...arr, ...newArr]
        }
        if (foundBold && (!foundLink || boldPos < linkPos)) {
            str = str.replace(foundBold[0], '')
            let newArr = [str.substr(0, boldPos), <span style={{fontWeight:500}} key={arr.length}>{foundBold[2]}</span>, str.substr(boldPos)];
            return [...arr, ...newArr]
        }
        return false
    }

    render() {
        const {label} = this.props;
        const processedStr = this.getProcessedStr(label)
        return (<>{parse(label)}</>)
    }
}
